// created from 'create-ts-index'

export * from './file-upload.response';
